import React, { Component } from 'react';
import { BrowserRouter as Router } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';

import Header from './containers/Header';
import Routes from './containers/Routes';
import Footer from './containers/Footer';

const styles = theme => ({
  site: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh'
  },
  content: {
    flex: '1 0 auto',
    padding: 'var(--space) var(--space) 0',
    width: '100%',
    ':after': {
      content: "'\\00a0'",
      display: 'block',
      marginTop: 'var(--space)',
      height: 0,
      visibility: 'hidden'
    }
  }
});

class Main extends Component {
  handleChange = (evt, value) => {
    this.setState({value})
  }

  render() {
    const { classes } = this.props;
    return (
      <Router>
        <div className={classes.site}>
          <div className={classes.content}>
          {((window.location.pathname !== '/dashboard')) && < Header /> }
            <Routes />
          </div>
          {((window.location.pathname !== '/dashboard')) && < Footer /> }
        </div>
      </Router>
    )
   }
}

export default withStyles(styles)(Main);
